import { render, staticRenderFns } from "./GBuyerDrawerMenu.vue?vue&type=template&id=3ef064c7&scoped=true&"
import script from "./GBuyerDrawerMenu.vue?vue&type=script&lang=ts&"
export * from "./GBuyerDrawerMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GBuyerDrawerMenu.vue?vue&type=style&index=0&id=3ef064c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef064c7",
  null
  
)

export default component.exports